<template>
    <div>
        <accordion
             v-if="investimentos.investimentoPropostaProponente" 
            :id="`sub_investimento${rubrica}1`"
            :title="investimentos.investimentoPropostaProponente.recebedora"
            sub
            :accordion="`sub_investimento${rubrica}1`"
            visible
            classTitulo="font-bold border-grey-300"
            variante="transparent"
        >    
            <template #append-title>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaProponente) == 0" variant="success" class="ml-2">Investimento finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaProponente) > 0" variant="danger" class="ml-2">Investimento não finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaProponente) < 0" variant="warning" class="ml-2">Alocação excede o previsto</b-badge>
            </template>   
            <investimento-t-r :rubrica="rubrica" :investimento="investimentos.investimentoPropostaProponente" :endpoint="endpoint" :aprovada="aprovada"/>
        </accordion>
        <accordion
             v-if="investimentos.investimentoProposta" 
            :id="`sub_investimento${rubrica}2`"
            :title="investimentos.investimentoProposta.recebedora"
            sub
            :accordion="`sub_investimento${rubrica}2`"
            visible
            classTitulo="font-bold border-grey-300"
            variante="transparent"
        >        
            <template #append-title>
                <b-badge v-if="calcularRestante(investimentos.investimentoProposta) == 0" variant="success" class="ml-2">Investimento finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoProposta) > 0" variant="danger" class="ml-2">Investimento não finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoProposta) < 0" variant="warning" class="ml-2">Alocação excede o previsto</b-badge>
            </template> 
            <investimento-t-r :rubrica="rubrica" :investimento="investimentos.investimentoProposta" :endpoint="endpoint" :aprovada="aprovada"/>
        </accordion>
        <accordion
             v-if="investimentos.investimentoPropostaCooperada" 
            :id="`sub_investimento${rubrica}2`"
            :title="investimentos.investimentoPropostaCooperada.recebedora"
            sub
            :accordion="`sub_investimento${rubrica}2`"
            visible
            classTitulo="font-bold border-grey-300"
            variante="transparent"
        >     
            <template #append-title>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaCooperada) == 0" variant="success" class="ml-2">Investimento finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaCooperada) > 0" variant="danger" class="ml-2">Investimento não finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimentos.investimentoPropostaCooperada) < 0" variant="warning" class="ml-2">Alocação excede o previsto</b-badge>
            </template>    
            <investimento-t-r :rubrica="rubrica" :investimento="investimentos.investimentoPropostaCooperada" :endpoint="endpoint" :aprovada="aprovada"/>
        </accordion>
        <accordion
            v-for="investimento,i in investimentos.investimentosPropostasCooperadas" :key="i"
            :id="`sub_investimento${rubrica}_${i}1`"
            :title="investimento.recebedora"
            sub
            :accordion="`sub_investimento${rubrica}_${i}1`"
            visible
            classTitulo="font-bold border-grey-300"
            variante="transparent"
        >       
            <template #append-title>
                <b-badge v-if="calcularRestante(investimento) == 0" variant="success" class="ml-2">Investimento finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimento) > 0" variant="danger" class="ml-2">Investimento não finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimento) < 0" variant="warning" class="ml-2">Alocação excede o previsto</b-badge>
            </template>  
            <investimento-t-r :rubrica="rubrica" :investimento="investimento" :endpoint="endpoint" :aprovada="aprovada"/>
        </accordion>
        <accordion
            v-for="investimento,i in investimentos.investimentosPropostasExecutoras" :key="i"
            :id="`sub_investimento${rubrica}_${i}2`"
            :title="investimento.recebedora"
            sub
            :accordion="`sub_investimento${rubrica}_${i}2`"
            visible
            classTitulo="font-bold border-grey-300"
            variante="transparent"
        >     
            <template #append-title>
                <b-badge v-if="calcularRestante(investimento) == 0" variant="success" class="ml-2">Investimento finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimento) > 0" variant="danger" class="ml-2">Investimento não finalizado</b-badge>
                <b-badge v-if="calcularRestante(investimento) < 0" variant="warning" class="ml-2">Alocação excede o previsto</b-badge>
            </template>    
            <investimento-t-r :rubrica="rubrica" :investimento="investimento" :endpoint="endpoint" :aprovada="aprovada"/>
        </accordion>
    </div>
</template>
<script>
import investimentoTR from "./investimentoTR"
import Accordion from "@/components/card/Accordion"
export default {
    props:{
        investimentos :{
            type: Object,
            required: true
        },
        rubrica : {
            required : true
        },
        endpoint : {
            required : true
        },
        aprovada : {
            default : false
        }
    },
    components: {
        Accordion,
        investimentoTR
    },
    methods : {
        calcularRestante(investimento){
            return Math.round(((investimento ? investimento.totalPrevisto : 0) -
                            (investimento ? investimento.totalAlocado : 0)) * 100) / 100
        }
    }
    
}
</script>
<style>
</style>